export const PaymentTypeConstants = {
    CARD: 'b64bb266-b985-42a0-895a-4243430a0642',
    EFT: '8b28d226-09c4-48e5-87f4-e2cdd76ed0bf'
};
